var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-of-use"},[_c('app-terms-of-use')],1)}
var staticRenderFns = []

export { render, staticRenderFns }